import { Component, OnInit, Input } from '@angular/core';
import {CustomformService} from './../../Service/CustomForm/customform.service';
import {CustomFormModel} from './../../Model/CustomForm/customform.model'
import {CustomFormValueModel,CustomFormValue} from '../../Model/CustomForm/customform.model';

@Component({
  selector: 'app-custom-form',
  templateUrl: './customform.component.html',
  styleUrls: ['./customform.component.css']
})
export class CustomFormComponent implements OnInit {
  @Input() customcontrol:CustomFormModel; 
  customFormValue:CustomFormValue;  
  selectedValue:any;
  
  constructor(private _CustomService:CustomformService) {  
    this.customcontrol=new CustomFormModel();
    this.customFormValue = new  CustomFormValue();
    this.customFormValue.CustomFormValues= new Array<CustomFormValueModel>();
    this.selectedValue=null
   }

   ngOnInit() {
   
  }

   saveInfo(){
    console.log(this.customcontrol);
    this.customcontrol.customControlTypes.forEach(obj => {
     
   
      
       var customFormValueModel=new CustomFormValueModel();
       customFormValueModel.fieldName=obj.name;
       customFormValueModel.fieldValue=obj.controlValue;
      this.customFormValue.CustomFormValues.push(customFormValueModel)
     
      this.customFormValue.Id=this.customcontrol.id//give form id here

      
     
   });     



    //call post method
    // debugger;
     console.log(  this.customFormValue,"api");
    this._CustomService.SaveFormData(this.customFormValue).subscribe(
      res=>{
        if(res.isSuccess)
        {
          console.log(res);
          this.customcontrol.customControlTypes.forEach(controlType => {
            controlType.controlValue="";      
          }); 
      
        }
       
     }
   )
    //Empty code on success
   
   }

   selectChange(data)
   {
      console.log(data, "onchange");
   }
}
